/**
 * SubmissionsTab — the Tab-3 body of the Ausschreibungs-Screen. Renders the Prozessschritt-5
 * Versicherer-Ranking & Auswahl (3a, Slice 7), then the Prozessschritt-6/7 Offertanfragen & Versand
 * section (3b, Slice 8), then the Rückfragen/Q&A placeholder (3c, Slice 9). The Versenden dialog's
 * open-state is lifted to the screen (the primary CTA) and threaded through.
 */

import { VersichererRankingSection } from './VersichererRankingSection';
import { SubmissionsSection } from './SubmissionsSection';
import { QnaSection } from './QnaSection';

export function SubmissionsTab({
  placementId,
  canWrite,
  versendenOpen,
  onVersendenClose,
}: {
  placementId: string;
  canWrite: boolean;
  versendenOpen?: boolean;
  onVersendenClose?: () => void;
}) {
  return (
    <div className="flex flex-col gap-6" data-testid="placement-submissions-tab">
      <VersichererRankingSection placementId={placementId} canWrite={canWrite} />

      <SubmissionsSection
        placementId={placementId}
        canWrite={canWrite}
        versendenOpen={versendenOpen}
        onVersendenClose={onVersendenClose}
      />

      {/* Prozessschritt 8 Rückfragen / Q&A (3c, Slice 9). */}
      <QnaSection placementId={placementId} canWrite={canWrite} />
    </div>
  );
}
